import React, { useState, useEffect } from 'react';
import { Modal, Button, Upload } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { AudioRecorder } from '../../AudioRecorder';
import { AudioPlaybackControls } from '../../AudioRecorder/AudioPlaybackControls';
import { createObjectURL, revokeObjectURL } from 'utils/window';
import useDirectUpload from '../../utils/useDirectUpload';
import styles from './UploadAudioModal.less';

export const UploadAudioModal = (props) => {
  const { onChange, onClose } = props;
  const [audioBlob, setAudioBlob] = useState(null);
  const [audioBlobUrl, setAudioBlobUrl] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadAudio] = useDirectUpload('UPLOAD_AUDIO');

  const handleRecordingStop = (blob) => {
    setAudioBlob(blob);
  };

  const handleFileUpload = (payload) => {
    const { file: blob } = payload;
    setAudioBlob(blob);
  };

  const handleUploadAudio = async () => {
    setIsUploading(true);
    const [audioFileKey] = await uploadAudio([{ blob: audioBlob, fileExtension: 'mp3' }]);
    onChange({ audioFileKey, audioBlob });
    setIsUploading(false);
    onClose();
  };

  useEffect(() => {
    if (!audioBlob) {
      return;
    }

    const audioBlobUrl = createObjectURL(audioBlob);

    setAudioBlobUrl(audioBlobUrl);

    return () => {
      revokeObjectURL(audioBlobUrl);
    };
  }, [audioBlob]);

  return (
    <Modal
      visible
      title="Upload Audio"
      footer={
        audioBlob && (
          <Button
            type="primary"
            icon={isUploading && <LoadingOutlined />}
            disabled={isUploading}
            onClick={handleUploadAudio}
          >
            Upload
          </Button>
        )
      }
      onCancel={onClose}
    >
      <div className={styles.audioRecordContainer}>
        <AudioRecorder label={false} showPlaybackControls={false} onStop={handleRecordingStop} />
        <div className={styles.instruction}>Click to start recording</div>
      </div>

      <div className={styles.fileUploadContainer}>
        <div className={styles.instruction}>Upload an audio file</div>
        <Upload.Dragger
          name="file"
          accept="audio/mp3"
          multiple={false}
          showUploadList={false}
          customRequest={handleFileUpload}
        >
          <p className="ant-upload-text">Click or drag file to this area to upload</p>
          <p className="ant-upload-hint">Supported Audio Types: mp3</p>
        </Upload.Dragger>
      </div>

      {audioBlobUrl && <AudioPlaybackControls url={audioBlobUrl} />}
    </Modal>
  );
};

UploadAudioModal.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
